module.exports = __webpack_public_path__ + "static/img/icon-close.cdba0c56.svg";